import React from 'react';
import { Link } from "react-router-dom";
import digitalmarketing from '../assets/images/pngicons/Digital-Marketing.jpg';
import itconsulting from '../assets/images/pngicons/IT-Consulting.jpg';
import processoutsourcing from '../assets/images/pngicons/business-process.png';
import webdesigndevelopment from '../assets/images/pngicons/Web-Design-&-Development.jpg';
import mobileappdevelopment from '../assets/images/pngicons/Mobile-App-Development.jpg';
import cloudserver from '../assets/images/pngicons/Cloud-Server.png';


export default function OurServices() {
  return (

<section className='product_section dbl_heading_section'> 

<div className='container  mt-5 mb-5'>

    <div className='row'>
        <div className='col-12'> <div className='hdsub_title'>WHAT WE DO</div> </div>
        <div className='col-12 mb-2'> <div className='hd_title'>Our Services</div> </div>
    </div>

<div className='row'>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
        <div className='d-flex align-items-center'>
            <div className='icon_holder'><img src={digitalmarketing} alt=''></img> </div>
            <div className='title'>Digital Marketing</div>
        </div>

    <div className='description'>
        <p>Our Digital marketing consulting involves providing expert advice and strategies to businesses seeking to enhance their online presence, increase engagement, and drive sales. We help businesses navigate the complexities of digital platforms, optimize campaigns, and measure performance to achieve sustainable growth and a competitive edge in the digital marketplace.</p>
    </div>
    <div className='readmore'>
    <Link to='/digital-marketing'>Read More</Link>

    </div>

    </div>
    
    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>
    
    <div className='d-flex align-items-center'>

    <div className='icon_holder'><img src={itconsulting} alt=''></img> </div>
    <div className='title'>DevOps Consulting Services</div>
    </div>

    <div className='description'>
        <p>Unlock the power of streamlined operations, faster development cycles, and enhanced collaboration with our expert DevOps consulting services. we help businesses transform their software development and IT operations by integrating automation, continuous integration/continuous delivery (CI/CD), cloud infrastructure management, and more.</p>
    </div>
    <div className='readmore'>
    <Link to='/devOps-consulting-services'>Read More</Link>

    </div>

    </div>

    </div>

    <div className='col-lg-4'>

    <div className='products_wrapper'>

    <div className='d-flex align-items-center'>
    <div className='icon_holder'><img src={webdesigndevelopment} alt=''></img> </div>
    <div className='title'>Website Design and Custom Software development</div>
    </div>


    <div className='description'>
        <p>We offer top-tier website design and custom software development services that help businesses build robust online presences, enhance user experiences, and drive business growth. Whether you need a custom website, custom web application, or fully integrated software solution, we have the expertise to turn your ideas into reality.</p>
    </div>
    <div className='readmore'>
    <Link to='/website-and-software-development'>Read More</Link>

    </div>

    </div>

    </div>


<div className='col-lg-4'>

<div className='products_wrapper'>

<div className='d-flex align-items-center'>
<div className='icon_holder'><img src={cloudserver} alt=''></img> </div>
<div className='title'>IT Consulting & Cloud Server management</div>
</div>


<div className='description'>
    <p>We offer expert IT consulting and cloud server management services designed to optimize your business's technology infrastructure, ensure smooth operations, and drive digital transformation. Whether you're looking to streamline your IT processes, enhance your cloud capabilities, or secure your server environment, we provide tailored solutions that empower your business to grow and thrive in the digital age.</p>
</div>
<div className='readmore'>
<Link to='/it-consulting-cloud-server-management'>Read More</Link>

</div>

</div>

</div>


<div className='col-lg-4'>

<div className='products_wrapper'>

<div className='d-flex align-items-center'>
<div className='icon_holder'><img src={processoutsourcing} alt=''></img> </div>
<div className='title'>Business Process Outsourcing</div>
</div>

<div className='description'>
    <p>We offer comprehensive Business Process Outsourcing (BPO) services that enable businesses to streamline operations, reduce costs, and focus on their core competencies. By outsourcing key business functions to our experienced team, you can enhance efficiency, improve service quality, and stay competitive in today's fast-paced market.</p>
</div>
<div className='readmore'>
<Link to='/business-process-outsourcing'>Read More</Link>

</div>

</div>

</div>

<div className='col-lg-4'>

<div className='products_wrapper'>
<div className='d-flex align-items-center'>
<div className='icon_holder'><img src={mobileappdevelopment} alt=''></img> </div>
<div className='title'>Mobile App Development Services</div>
</div>



<div className='description'>
    <p>We specialize in delivering mobile app development services that help businesses create innovative, user-friendly, and high-performance mobile applications. Whether you're looking to develop an app for iOS, Android, or cross-platform, our team of expert developers provides end-to-end mobile app solutions tailored to your business needs.</p>
</div>
<div className='readmore'>
<Link to='/mobile-app-services'>Read More</Link>

</div>

</div>

</div>

</div>

</div>
</section>


  )
}
